import { render } from "./pageView.vue?vue&type=template&id=66116f36&scoped=true"
import script from "./pageView.vue?vue&type=script&lang=js"
export * from "./pageView.vue?vue&type=script&lang=js"

import "./pageView.vue?vue&type=style&index=0&id=66116f36&scoped=true&lang=css"

import exportComponent from "/Users/yxgc/Documents/workspace/BeeUiComentPlugin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66116f36"]])

export default __exports__